import React from "react";

function AdvertisementSection() {
    const ads = [
        { id: 1, image: "/assets/1260gif.gif", link: "#" },
        { id: 2, image: "/assets/1260gif.gif", link: "#" },
        { id: 3, image: "/assets/1260gif.gif", link: "#" }
    ];

    return (
        <div style={{ width: "100%" }} >
            {/* Internal CSS */}
            <style>{`
                .ad-image {
                    width: 100%;
                    height: 200px; 
                    object-fit: cover;
                    border-radius: 6px;
                }
                @media (max-width: 576px) {
                    .ad-image {
                        height: 90px;
                    }
                }
            `}</style>

            <div
                id="adsCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="1500"   // 1.5 seconds slide time
            >
                <div className="carousel-inner">

                    {ads.map((ad, index) => (
                        <div
                            key={ad.id}
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                        >
                            <a href={ad.link}>
                                <img
                                    src={ad.image}
                                    alt={`Advertisement ${ad.id}`}
                                    className="ad-image d-block w-100"
                                />
                            </a>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
}

export default AdvertisementSection;
